import { GeneralResponse } from '../models/generalResponse'

export function validateUser(userRepository, contextData, usersData, challenge) {
  return userRepository.validate(contextData, usersData, challenge).then(data => new GeneralResponse(data));
}